import React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'
import { TextWithLinks } from 'main/ui'

function PrivacyDisclaimer() {
  const { t } = useTranslation(NAMESPACE)
  const { isWhitelabeled, i18nSuffix: suffix } = useWhitelabel()

  return (
    <>
      {!isWhitelabeled && (
        <TextWithLinks>
          {t(`LOGIN-PAGE-TOS-PRIVACY-DISCLAIMER`, {
            tos: '/terms-of-use',
            privacy: '/privacy-policy',
          })}
        </TextWithLinks>
      )}
      {isWhitelabeled && (
        <TextWithLinks>
          {t(`LOGIN-PAGE-TOS-PRIVACY-DISCLAIMER${suffix}`, {
            ws_eli_tos: 'https://corp.wonderschool.com/eli-terms',
            ws_eli_privacy: 'https://corp.wonderschool.com/eli-privacy',
            eli_tos: 'https://theearlylearningmarketplace.org/terms/',
            eli_privacy: 'https://theearlylearningmarketplace.org/privacy/',
          })}
        </TextWithLinks>
      )}
    </>
  )
}

export default PrivacyDisclaimer
